<template>
  <div class="d-flex align-items-center gap-2">
    <div class="spinner-border spinner-border-sm text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <span class="fw-bold">{{ seconds }} сек</span>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, defineProps } from 'vue'

const props = defineProps({
  duration: {
    type: Number,
    default: 60 // по умолчанию 60 секунд
  }
})

const seconds = ref(0)
let interval = null

onMounted(() => {
  interval = setInterval(() => {
    if (seconds.value < props.duration) {
      seconds.value++
    } else {
      clearInterval(interval)
    }
  }, 1000)
})

onUnmounted(() => {
  if (interval) {
    clearInterval(interval)
  }
})
</script>

<style scoped>
/* Можно добавить кастомные стили при необходимости */
.spinner-border {
  width: 1rem;
  height: 1rem;
}
</style>
